export const productOptions = [
  { value: "fertilizante-npk-15-15-15", label: "Fertilizante NPK 15-15-15" },
  { value: "abono-organico-compost", label: "Abono orgánico compost" },
  { value: "semilla-platano-harton", label: "Semilla de plátano hartón" },
  { value: "kit-herramientas", label: "Kit de herramientas agrícolas" },
];

export const defaultAlertedProductsFilters = {
  operationalDay: null,
  alertCategory: null,
  managementType: null,
  alertManagement: null,
  documentoTitular: "",
  cub: "",
  ordenNumero: "",
  department: null,
  municipality: null,
  idProducto: "",
  supplier: [],
  products: [],
};
